<template>
  <div class="h100">
    <el-tabs v-model="activeName" @tab-click="handleClick" class="pt-2 h100">
      <el-tab-pane name="menuConfig" class="h100">
        <span slot="label"><span class="tab-label">菜单管理</span></span>
        <menuConfig></menuConfig>
      </el-tab-pane>
      <el-tab-pane name="pageConfig" class="h100">
        <span slot="label"><span class="tab-label">页面资源配置</span></span>
        <pageConfig></pageConfig>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import menuConfig from "./menuConfig/menuConfig";
import pageConfig from "./pageConfig/pageConfig";

export default {
  name: "ResourceMange",
  components: {menuConfig, pageConfig},
  data() {
    return {
      activeName: "menuConfig"
    };
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    }
  }
};
</script>

<style scoped lang="scss">
  .tab-label{
    /*padding: 0 20px*/
  }

  ::v-deep .el-tabs__header {
    margin: 0;
    .el-tabs__nav{
      margin-left: 20px;
    }
  }

  ::v-deep .el-tabs__content {
    height: calc(100% - 39px);
  }
</style>


